import { render, staticRenderFns } from "./coaching.vue?vue&type=template&id=44e895b2&scoped=true&"
import script from "./coaching.vue?vue&type=script&lang=js&"
export * from "./coaching.vue?vue&type=script&lang=js&"
import style0 from "./coaching.vue?vue&type=style&index=0&id=44e895b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e895b2",
  null
  
)

export default component.exports